import { apiGet } from "./requests";

export const getProducts = () => {
  const path = "products";
  return apiGet(path);
};

export const getCategories = () => {
  const path = "product-categories";
  return apiGet(path);
};

export const getProduct = (data = null) => {
  const path = `/get-product-info/${data}`;
  return apiGet(path);
};

export const searchCustomerInformation = (data = null) => {
  // Mantiene el mismo endpoint y formato, pero evita romper el query string
  const filter = data == null ? "" : encodeURIComponent(String(data));
  const path = `search-customer-information?filter=${filter}`;
  return apiGet(path);
};

export const getShippingMethods = () => {
  const path = "shipping-methods";
  return apiGet(path);
};

export const getPaymentMethods = () => {
  const path = "payment-methods";
  return apiGet(path);
};
